import Spo from '@data/model/NewModals/Spo/spo'
import {
	CREATE_NEW_SPO,
	FETCH_CATEGORIES_FAILURE,
	FETCH_CATEGORIES_PROGRESS,
	FETCH_CATEGORIES_SUCCESS,
	FETCH_BRANDS_FAILURE,
	FETCH_BRANDS_PROGRESS,
	FETCH_BRANDS_SUCCESS,
	FETCH_USERS_FAILURE,
	FETCH_USERS_PROGRESS,
	FETCH_USERS_SUCCESS,
	SET_SELECTED_USER,
	SET_QUOTE_TYPE,
	UPDATE_SPO,
	ADD_NEW_SPO_ITEM,
	UPDATE_SPO_ITEM,
	DELETE_SPO_ITEM,
	CREATE_SPO_FROM_DATA,
	CLEAR_SPO_STATE,
} from './actions'
import { displayName } from '@utils'
import { SpoEnquiryItem, User } from '@data/model'

export const StatusMap = {
	IN_PROGRESS: 'IN_PROGRESS',
	SUCCESS: 'SUCCESS',
	FAILURE: 'FAILURE',
}

export const initialStateSpo = {
	newSpo: null,
	newSpoStatus: null,
	categories: {
		loading: false,
		error: null,
		data: null,
	},
	brands: {
		loading: false,
		error: null,
		data: null,
	},
	users: {
		loading: false,
		error: null,
		data: null,
	},
	selectedUser: null,
}

export const reducer = (state = initialStateSpo, action) => {
	switch (action.type) {
		case CREATE_NEW_SPO: {
			const user = action.user
			const newSpo = new Spo()
			return { ...state, newSpo }
		}

		case CREATE_SPO_FROM_DATA: {
			const data = action.payload
			const newSpo = new Spo(data)
			const selectedUser = new User(data?.supplier)?.getUserDetails()
			const newSpoStatus = data?.supplier_po_status
			if (selectedUser) {
				selectedUser['display_name'] = displayName(selectedUser)
			}

			return { ...state, newSpo, selectedUser, newSpoStatus }
		}

		case CLEAR_SPO_STATE: {
			return { ...initialStateSpo }
		}

		case FETCH_CATEGORIES_PROGRESS: {
			return {
				...state,
				categories: {
					loading: true,
				},
			}
		}

		case FETCH_CATEGORIES_FAILURE: {
			return {
				...state,
				categories: {
					loading: false,
					error: action.error,
				},
			}
		}

		case FETCH_CATEGORIES_SUCCESS: {
			return {
				...state,
				categories: {
					loading: false,
					data: action.payload,
				},
			}
		}

		case FETCH_BRANDS_PROGRESS: {
			return {
				...state,
				brands: {
					loading: true,
				},
			}
		}

		case FETCH_BRANDS_FAILURE: {
			return {
				...state,
				brands: {
					loading: false,
					error: action.error,
				},
			}
		}

		case FETCH_BRANDS_SUCCESS: {
			return {
				...state,
				brands: {
					loading: false,
					data: action.payload,
				},
			}
		}

		case FETCH_USERS_PROGRESS: {
			return {
				...state,
				users: {
					loading: true,
				},
			}
		}

		case FETCH_USERS_SUCCESS: {
			let _users
			if (Array.isArray(action.payload)) {
				_users = action.payload?.map((item) => {
					item['display_name'] = displayName(item)
					return item
				})
			}
			return {
				...state,
				users: {
					loading: false,
					data: _users,
				},
			}
		}

		case FETCH_USERS_FAILURE: {
			return {
				...state,
				users: {
					loading: false,
					error: action.error,
				},
			}
		}

		case SET_SELECTED_USER: {
			const selectedUser = action.payload
			let newSpo = state?.newSpo
			newSpo = newSpo.update({
				supplier: action.payload,
				dispatch_location: null,
				billing_address: null,
				payment_terms_list: action.payload?.supplier_payment_terms ?? null,
			})
			return {
				...state,
				selectedUser,
				newSpo,
			}
		}

		case SET_QUOTE_TYPE: {
			let newSpo = state?.newSpo

			if (newSpo && action.payload) {
				newSpo = newSpo?.update(action.payload)
			}
			return { ...state, newSpo }
		}

		case UPDATE_SPO: {
			let newSpo = state?.newSpo

			if (newSpo && action.payload) {
				newSpo = newSpo?.update(action.payload)
			}
			return { ...state, newSpo }
		}

		case ADD_NEW_SPO_ITEM: {
			let newSpo = state?.newSpo
			if (newSpo) {
				const orderItem = new SpoEnquiryItem(action.payload)
				newSpo = newSpo.addNewItem(orderItem)
				return { ...state, newSpo }
			}
			return state
		}

		case DELETE_SPO_ITEM: {
			let newSpo = state?.newSpo
			if (newSpo) {
				newSpo = newSpo.deleteItem(action.payload)
			}
			return { ...state, newSpo }
		}

		case UPDATE_SPO_ITEM: {
			let newSpo = state?.newSpo
			if (newSpo && action.payload?.itemId) {
				const enquiryItem = new SpoEnquiryItem(action.payload?.orderItem)
				newSpo = newSpo.updateItem(action.payload?.itemId, enquiryItem)
				return { ...state, newSpo }
			}
			return state
		}

		default: {
			return null
		}
	}
}
